import { Component, OnInit } from '@angular/core';
import { LanguageComponent } from '../core/language/language.component';
import { SearchService } from './shared/search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  searchTerm: string;
  itemCount: number;
  initialTabindex: number;

  constructor(private searchService: SearchService) { }

  ngOnInit() {
    this.searchService.getSearchbarTabindex().subscribe(val => {
      this.initialTabindex = val;
    });
  }

  onSearchTermChange(evt) {
    setTimeout(()=>{
      this.searchTerm = evt.searchTerm;
      this.itemCount = evt.itemCount;
    })
  }
}
